import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { ActionService } from 'dashboard-services/services';

import { AuthUtils } from 'utils';

export default (() => {
  
  const ON_CHANGE = 'ON_CHANGE_SETTINGS'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const hasTesterAccess = () => (_, getState) => {
    const uiEntitlements = getState().settingsState.uiEntitlements
    return AuthUtils.hasTesterAccess({ uiEntitlements })
  }

  const DEFAULT_COLUMNS = ["Close", "Index", "Mid", "Last", "Value", "Volume", "Price", "Settlement", "Forecast", "CAP_OFFLINE"]
  const ORDERED_COLUMN_KEYS = [
    { label: "Product", filterKey: "Product", type: DataStorageEnums.KEY_TYPE.METADATA, isHidden: false },
    { label: "Source", filterKey: "Source", type: DataStorageEnums.KEY_TYPE.METADATA, isHidden: false },
    { label: "Region", filterKey: "SourceRegion", type: DataStorageEnums.KEY_TYPE.METADATA, isHidden: false },
    { label: "Market", filterKey: "Market", type: DataStorageEnums.KEY_TYPE.METADATA, isHidden: false },
    { label: "FuturesRoot", filterKey: "FuturesRoot", type: DataStorageEnums.KEY_TYPE.METADATA, isHidden: false },
    { label: "Symbol", filterKey: "Symbol", type: DataStorageEnums.KEY_TYPE.SYMBOL, isHidden: false },
    { label: "Description", filterKey: "Description", type: DataStorageEnums.KEY_TYPE.METADATA, isHidden: false }
  ]

  return {
    onChange,
    ON_CHANGE,
    hasTesterAccess,
    DEFAULT_COLUMNS,
    ORDERED_COLUMN_KEYS
  }
})()